import PropTypes from 'prop-types';
import {createComponent} from './components';

const
    createContainer = (
        (name,
        {
            propTypes = {},
            defaultProps = {}
        } = {},
        enhance,
        container) => (

        enhance(
            createComponent(
                name,
                {
                    propTypes: {
                        ...propTypes,
                        children: PropTypes.func.isRequired
                    },
                    defaultProps
                },
                container || (({children, ...props}) => children(props))))));

export {
    createContainer
};
